import {createStyles, Theme} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";

export const PatientsListStatusFilterStyle = createStyles({
    root: {
        width: 260,
        marginRight: '16px',
    },
    selectWrapper: {
        width: '100%',
    },
    placeholder: {
        color: 'rgba(0, 0, 0, 0.54)',
    },
});

export const usePatientsListStatusFilterStyle = makeStyles((theme: Theme) => PatientsListStatusFilterStyle);
